import {Button, Typography} from '@material-ui/core';
import React, {useState} from 'react';

import AgentDialog from './AgentDialog';
import AgentTabularList from './AgentTabularList';

import {MAX_AGENT} from 'ApplicationEntry/models/AgentInformation';
import {InvalidApplication, ValidApplication} from 'ApplicationEntry/models/Application';
import './../ContingentBeneficiary/ContingentBeneficiary.sass';

type AgentsProps = {
  application: InvalidApplication | ValidApplication;
};

export default function Agents(props: AgentsProps) {
  const {application} = props;

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="contingent-beneficiary-section">
      <div className="contingent-beneficiary-section__main-header">
        <Typography variant="subtitle1" className="contingent-beneficiary-section__head" color="primary">
          Agents List 
        </Typography>

        <Button
          variant="contained"
          color="primary"
          disabled={application.agentList.agentList.size >= MAX_AGENT ? true : false}
          onClick={handleClickOpen}
        >
          ADD AGENT
        </Button>
      </div>
      {application.agentList.agentList.size < 1 ? (
        <>
          <div className="contingent-beneficiary-section__no-item">
            <div className="contingent-beneficiary-section__box">
              <div className="contingent-beneficiary-section__image" />

              <h3 className="contingent-beneficiary-section__title">No Agents</h3>
              <Typography className="contingent-beneficiary-section__content" variant="body2" color="initial">
                Click the "Add Agent" button above to add an agent
              </Typography>
            </div>
          </div>
        </>
      ) : (
        <AgentTabularList agentItem={application.agentList} application={application} />
      )}

      <AgentDialog
        dialogOpen={open}
        dialogClose={handleClose}
        dialogTitle="Add Agent(s)"
        dialogSubTitle="Agent(s) Information"
        dialogAdditional="ADDITIONAL AGENT"
        application={application}
        agentIndex={application.agentList.agentList.size}
        editAgent={false}
      />
    </div>
  );
}
